module.exports = __webpack_public_path__ + "static/media/07.Falicitation in Kala Kuncha - Bhaskar Kogga Kamath.5aa0686a.jpg";